import Background from './components/Background';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import StatsTicker from './components/StatsTicker';
import Features from './components/Features';
import CTA from './components/CTA';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="relative min-h-screen bg-background-dark text-white overflow-x-hidden">
      <Background />
      <Navbar />
      <main className="relative z-10 pt-20 sm:pt-24">
        <Hero />
        <StatsTicker />
        <Features />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
